/* tslint:disable */
 
import { FunctionParameters } from './function-parameters';
import { LocalizedValue } from './localized-value';

/**
 * (tsType: FunctionDTO, schemaOptions: { includeRelations: false })
 */
export class FunctionDto {
  id?: string;
  name: LocalizedValue;
  normalizedName: string;
  parameters?: Array<FunctionParameters>;
}
